/**
* Storage og segment object from $post
**/

import { Injectable } from '@angular/core';

// Import RxJs required methods



@Injectable()
export class SegmentService {

    private $post = JSON.parse(sessionStorage.getItem('$post'));

    private segment: any;

    public getSegment( _search: any ) : void{
        this.segment = _search.segment;
        return this.segment;
    }

}
